import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export interface UserInfo {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
    isSystemUser: boolean;
    clients?: any[];
    permissions?: any[];
}

@Injectable({ providedIn: 'root' })
export class AuthService {
    http: HttpClient;
    baseUrl: string;
    constructor(http: HttpClient) {
        this.baseUrl = `${environment.apiUrl}/auth`;
        //  const moduleName = 'AuthManagement';
        this.http = http;
    }

    /**
     * Decode JWT token and extract user information
     */
    getUserInfoFromToken(): UserInfo | null {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return null;

            const payload = token.split('.')[1];
            const decodedPayload = JSON.parse(atob(payload));

            return {
                id: decodedPayload.id,
                email: decodedPayload.email,
                firstName: decodedPayload.firstName,
                lastName: decodedPayload.lastName,
                fullName: `${decodedPayload.firstName} ${decodedPayload.lastName}`,
                isSystemUser: decodedPayload.isSystemUser || false,
                clients: decodedPayload.clients,
                permissions: decodedPayload.permissions
            };
        } catch (error) {
            console.error('Error decoding token:', error);
            return null;
        }
    }

    get isSystemUser(): boolean {
        const user = this.getUserInfoFromToken();
        return user?.isSystemUser === true;
    }

    // Custom methods if needed
    login(data: any) {
        return this.http.post(`${this.baseUrl}/login`, data);
    }

    resetPassword(email: string, data: any) {
        return this.http.post(`${this.baseUrl}/admin/set-password/${email}`, data);
    }
}
